import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "./store";
import Loader from "./components/Loader/Loader";
import Router from "./Routes/Router";
import WarningDialog from "./components/WarningDialog/WarningDialog";
import "./App.css";
import TranslateComponent from "./components/LanguageTranslate";

function App() {
  const language = useSelector((state: RootState) => state.language.language);
  useEffect(() => {
    // This runs only once when the component mounts
    if (!sessionStorage.getItem("keepLocalStorage")) {
      localStorage.removeItem("patientData");
      localStorage.removeItem("isPatientPortalData");
      sessionStorage.setItem("keepLocalStorage", "true");
    }
  }, []);

  return (
    <div className='App'>
      <div className={`translator ${language === "ar" ? "rtlDirection" : ""}`}>
        <TranslateComponent />
      </div>
      <WarningDialog />
      <Loader />
      <Router />
    </div>
  );
}

export default App;
